import EventEmitter from './EventEmitter.js'

export default class Sizes extends EventEmitter {

    static _instance = null

    static getInstance(container = null) {
        return Sizes._instance || new Sizes(container)
    }

    constructor(container = null) {
        // Singleton
        if ( Sizes._instance ) {
            return Sizes._instance
        }

        super()

        Sizes._instance = this

        this.container = container

        this.sizes = {
            width: 0,
            height: 0,
            pixelRatio: 0,
            aspectRatio: 0,
            orientation: 'portrait'
        }


        this.addEventListeners()
        this.onResize()
    }

    get aspectRatio() {
        return this.sizes.aspectRatio
    }

    get pixelRatio() {
        return this.sizes.pixelRatio
    }

    get width() {
        return this.sizes.width
    }

    get height() {
        return this.sizes.height
    }

    addEventListeners() {
        this.resizeTimeout = null;
        window.addEventListener('resize', () => {
            if (this.resizeTimeout) {
                clearTimeout(this.resizeTimeout);
            }
            
            this.resizeTimeout = setTimeout(() => {
                this.onResize();
            }, 200);
        });
    }

    onResize() {
        const newWidth = this.container ? this.container.clientWidth : window.innerWidth
        const newHeight = this.container ? this.container.clientHeight : window.innerHeight

        if ( newWidth !== this.sizes.width || newHeight !== this.sizes.height ) {
            this.resize(newWidth, newHeight)
        }
    }

    resize(newWidth, newHeight) {
        this.sizes.width = newWidth
        this.sizes.height = newHeight
        this.sizes.pixelRatio = Math.min( window.devicePixelRatio, 2 )
        this.sizes.aspectRatio = this.sizes.width / this.sizes.height
        this.sizes.orientation = this.getOrientation()
        this.isMobile = this.getIsMobile()
        this.trigger( 'resize' )
    }

    getIsMobile() {
        return window.matchMedia("(max-width: 767px)").matches
    }

    getOrientation() {
        return window.matchMedia("(orientation: portrait)").matches ? 'portrait' : 'landscape'
    }

}
